import { render, staticRenderFns } from "./BetCard.vue?vue&type=template&id=7f51e0b8&scoped=true"
import script from "./BetCard.vue?vue&type=script&lang=js"
export * from "./BetCard.vue?vue&type=script&lang=js"
import style0 from "./BetCard.vue?vue&type=style&index=0&id=7f51e0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f51e0b8",
  null
  
)

export default component.exports